import { useEffect } from "react";

function AutoLogoutAtNight({ userType }) {
  useEffect(() => {
    const interval = setInterval(() => {
      const now = new Date();

      // Время по Киеву
      const kievTime = new Date(
        now.toLocaleString("en-US", { timeZone: "Europe/Kyiv" })
      );

      const hours = kievTime.getHours();
      const minutes = kievTime.getMinutes();

      if (hours === 4 && minutes === 0) {
        console.log("🕒 3:50 по Киеву — удаляем токен и перезагружаем");

        localStorage.removeItem("token");
        localStorage.removeItem("savedLogin");
        localStorage.removeItem("savedPassword");

        const redirectTo = userType ? `/${userType}/general` : "/";
        window.location.href = redirectTo;
      }
    }, 60 * 1000); 

    return () => clearInterval(interval);
  }, [userType]);

  return null;
}

export default AutoLogoutAtNight;
